import { render, staticRenderFns } from "./AlertRules.vue?vue&type=template&id=ee0d610c"
import script from "./AlertRules.vue?vue&type=script&lang=js"
export * from "./AlertRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports